import type { RouteRecordRaw } from "vue-router";
import {
  FORGOT_PASSWORD_PATH,
  LOGIN_EMAIL_PATH,
  LOGIN_MAGIC_LINK_PATH,
  LOGIN_PATH,
  LOGOUT_PATH,
  RESET_PASSWORD_PATH,
  ROUTE_NAME,
  SELECT_ORGANIZATION_PATH,
} from "@/shared/constants/routes";

export const routes: RouteRecordRaw[] = [
  {
    path: LOGIN_PATH,
    name: ROUTE_NAME.LOGIN,
    component: () => import("./views/LoginWelcomeView.vue"),
  },
  {
    path: LOGIN_EMAIL_PATH,
    name: ROUTE_NAME.LOGIN_PASSWORD,
    component: () => import("./views/LoginPasswordView.vue"),
    props: true,
  },
  {
    path: LOGOUT_PATH,
    name: ROUTE_NAME.LOGOUT,
    component: () => import("./views/LogoutView.vue"),
  },
  {
    // Authenticated on purpose — you need a session before you can switch orgs.
    path: SELECT_ORGANIZATION_PATH,
    name: ROUTE_NAME.SELECT_ORGANIZATION,
    component: () => import("./views/SelectOrganizationView.vue"),
  },
  {
    path: FORGOT_PASSWORD_PATH,
    name: ROUTE_NAME.FORGOT_PASSWORD,
    component: () => import("./views/ForgotPasswordView.vue"),
  },
  {
    path: RESET_PASSWORD_PATH,
    name: ROUTE_NAME.RESET_PASSWORD,
    component: () => import("./views/ResetPasswordView.vue"),
  },
  {
    path: LOGIN_MAGIC_LINK_PATH,
    name: ROUTE_NAME.LOGIN_MAGIC_LINK,
    component: () => import("./views/LoginMagicLinkView.vue"),
  },
];
